<template>
  <div class="light bg-muted-100 dark:bg-muted-900 relative flex min-h-screen w-full flex-col overflow-hidden">
    <div class="grow">
      <slot />
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue'
import { startProcessingMocaEvents, stopProcessingMocaEvents } from '~/pages/utils/mocaEvents'

onMounted(() => {
  startProcessingMocaEvents()
})

onBeforeUnmount(() => {
  stopProcessingMocaEvents()
})

</script>
